import React from 'react';
import { BreadCrumb } from '@helpcenter/bread-crumb-dumb';
import { useIntl } from 'react-intl';
import { graphql, useFragment } from 'react-relay';
import Breadcrumbs from '@atlaskit/breadcrumbs/breadcrumbs';
import { Box } from '@atlaskit/primitives/box';
import { useHelpCenterMessageDictionary } from '../../utils/help-center-messages';
import type { settingsBreadcrumbsFragment$key } from './__generated__/settingsBreadcrumbsFragment.graphql';
import messages from './messages';

interface SettingsBreadcrumbsProps {
	helpCenterData: settingsBreadcrumbsFragment$key;
}

const SettingsBreadcrumbs = ({ helpCenterData }: SettingsBreadcrumbsProps) => {
	const data = useFragment(
		graphql`
			fragment settingsBreadcrumbsFragment on HelpCenter {
				name {
					default
				}
				slug @optIn(to: "HelpCenterSlugTest")
			}
		`,
		helpCenterData,
	);
	const helpCenterName = data?.name?.default || '';
	const slug = data?.slug;
	const { formatMessage } = useIntl();
	const helpCenterMessages = useHelpCenterMessageDictionary();

	const rootBreadcrumbUrl: string = '/';

	const getHelpcenterBreadcrumbUrl = () => {
		return !slug
			? `${window.location.origin}/servicedesk/customer`
			: `${window.location.origin}/helpcenter/${slug}`;
	};

	return (
		<Box paddingBlockStart="space.400">
			<Breadcrumbs label={formatMessage(messages.breadcrumbsLabel)}>
				<BreadCrumb
					isFirstCrumb
					to={rootBreadcrumbUrl}
					name={formatMessage(helpCenterMessages.breadcrumbRoot)}
					actionSubjectId="helpCenterBreadcrumb"
					disableTheme
				>
					<BreadCrumb
						to={getHelpcenterBreadcrumbUrl()}
						name={helpCenterName}
						actionSubjectId="helpDeskBreadcrumb"
						disableTheme
					></BreadCrumb>
				</BreadCrumb>
			</Breadcrumbs>
		</Box>
	);
};

export default SettingsBreadcrumbs;
